import FIcon from "@components/FIcon";
import { ContentReviewDeliverable } from "@types";
import {
  displayCounts,
  getDeliverableStatus,
  getStatusBadge,
} from "@utils/CampaignUtils";

interface DeliverableInfoProps {
  deliverable: ContentReviewDeliverable;
}

const DeliverableInfo = ({ deliverable }: DeliverableInfoProps) => {
  const { platform, name } = deliverable;

  const status = getDeliverableStatus(deliverable);

  return (
    <div className="flex items-center w-full">
      <div className="flex items-center justify-center w-[44px] min-w-[44px] border border-default_weak h-[44px] rounded-full">
        <FIcon icon={platform} size={18} color="#000F45" />
      </div>
      <div className="flex flex-col justify-center ml-4 w-full">
        <div className="flex justify-between w-full items-center gap-2">
          <h4 className="text-lg text-dark_night_sky capitalize">{name}</h4>
          <div className="block sm:hidden">{getStatusBadge(status)}</div>
        </div>
        {displayCounts(deliverable)}
      </div>
    </div>
  );
};

export default DeliverableInfo;
